import React, { Component } from 'react';
import './styles.css';

class ComponentePagination extends Component {
    getPageNumbers = () => {
        const { curPage, paginas } = this.props;
        const currentPage = parseInt(curPage); // Convert to number
        
        // If we have 7 or fewer pages, show all pages
        if (paginas <= 7) {
            return Array.from({ length: paginas }, (_, i) => i + 1);
        }

        // Always show first and last page
        let pages = [];
        
        if (currentPage <= 4) {
            // Near the start
            pages = [1, 2, 3, 4, 5, '...', paginas];
        } else if (currentPage >= paginas - 3) {
            // Near the end
            pages = [1, '...', paginas - 4, paginas - 3, paginas - 2, paginas - 1, paginas];
        } else {
            // In the middle
            pages = [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', paginas];
        }
        
        return pages;
    };

    render() {
        const { curPage, paginas, function: onPageClick } = this.props;
        const currentPage = parseInt(curPage); // Convert to number

        if (paginas <= 0) return null;

        const pageNumbers = this.getPageNumbers();

        return (
            <div className="col-md-12">
                <div className="text-center paginate">
                    {pageNumbers.map((page, index) => (
                        <span
                            key={`${page}-${index}`}
                            id={page === '...' ? `ellipsis-${index}` : page}
                            onClick={page === '...' ? null : onPageClick}
                            className={`${currentPage === page ? 'selected' : ''} ${page === '...' ? 'ellipsis' : ''}`}
                        >
                            {page}
                        </span>
                    ))}
                </div>
            </div>
        );
    }
}

export default ComponentePagination;